import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import deleteImg from '../../../assets/icons/delete-files.svg';
import exclamationIcon from '../../../assets/icons/icon-exclamation-mark.svg';
import './styles.css'
import ImportIcon from '../../../assets/icons/icon-import.svg'
import Dropdown from "../../../components/atoms/Dropdown";
import { useMainContext } from "../../../contexts/MainContext";
import { useCatalogsContext } from "../../../contexts/CatalogsContext";

const ModalCreateUser = (props) => {
    let mainContext = useMainContext();
    let catalogs = useCatalogsContext();
    const { showModal, setShow, setCancelAction, handlerAccept, cancel, success, edit, dataUser } = props
    const [nameFile, setNameFile] = useState("Seleccionar archivo")
    const [stringFile, setStringFile] = useState("")
    const [rol, setRol] = useState("")
    const [formData, setFormData] = useState({})
    const [stateData, setStateData] = useState([])
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(false);
    const [disablesInputs, setDisablesInputs] = useState(false);
    /**
        * Cierra el modal.
    */
    const handleClose = () => {
        setNameFile("Seleccionar archivo")
        setFormData({})
        setIsSubmitted(false)
        setShow(false);
        setIsValidEmail(false)
    }
    const sendData = async () => {
        setIsSubmitted(true)

        if (valitation()) {

            await handlerAccept(formData)
            await setFormData({})
            setIsSubmitted(false)
            setIsValidEmail(false)
        }

    }
    const valitation = () => {

        if (!formData
            || formData.userName === undefined
            || formData.fullName === undefined
            || formData.rol === undefined
            || formData.office === undefined
            || formData.status === undefined
            || formData?.userName.trim() === ""
            || formData?.fullName.trim() === ""
            || formData.rol === ""
            || formData.office === ""
            || formData.status === ""
            || formData.userName === null
            || formData.fullName === null
            || formData.rol === null
            || formData.office === null
            || formData.status === null
            || isValidEmail)
            return false
        else
            return true
    }

    /**
        * Comfirmacion de borrado.
    */
    useEffect(() => {
        setIsSubmitted(false)
        setFormData({})
        setNameFile("Seleccionar archivo")
        if (edit) {
            setDisablesInputs((mainContext?.session?.userID == formData?.userID) ? true : false)
            setFormData({
                fullName: dataUser.fullName,
                office: initCombo("offices", "officeID", dataUser.officeID),
                rol: initCombo("roles", "roleID", dataUser.roleID),
                status: initCombo("status", "id", dataUser.status ? 1 : 0),
                userID: dataUser.userID,
                userName: dataUser.userName
            })
        }

    }, [showModal, dataUser])


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    const getFileBase64 = async (event) => {
        setNameFile(event.name)
        const result = await toBase64(event);
        setStringFile(result)
    }

    const onFormDataChange = async (name, e) => {
        setFormData({ ...formData, [name]: e.value });

    }
    const handleBlur = (e) => {
        if (!e)
            setIsValidEmail(false)
        else if (!validateEmail(e))
            setIsValidEmail(true)
        else
            setIsValidEmail(false)

    };
    const validateEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    const initCombo = (catalog, filterBy1, filterBy2) => {
        let status = [{ "id": 1, "status": "Activo" }, { "id": 0, "status": "Inactivo" }];
        if (catalog == "status") {
            let dato = status.filter((element) => { return element[filterBy1] == filterBy2 })[0];
            return dato;
        } else if (catalogs[catalog]) {

            let dato = catalogs[catalog].filter((element) => { return element[filterBy1] == filterBy2 })[0];
            return dato;
        } else
            return null;
    }

    return (
        //TODO: Fix styles
        <section>
            <Modal size={"one-input-form"} show={showModal} onHide={() => { handleClose() }} backdrop="static" centered >
                <Modal.Header className="no-border p-1" closeButton>
                    <Modal.Title className="pl-3"></Modal.Title>
                </Modal.Header>
                <Modal.Body className={"text-center"} >
                    <div className="custom-card">
                        <div className="custom-card-header px-3 d-flex">
                            <h4 className="py-3">{edit ? "EDITAR" : "AGREGAR"} USUARIO</h4>
                            <div className=" py-2 d-flex justify-content-end">
                                {/*<button onClick={() => { setShowModal(true) }} className="btn btn-primary"><span className="d-inline-block pr-4">Nueva importación</span> +</button>*/}.
                            </div>
                        </div>
                        <div className="custom-card-body px-3">
                            <div className="row">
                                <div className="form-group with-message col-6">
                                    <label className="input-label form-label">
                                        * Username
                                    </label>
                                    <div className="">
                                        {
                                            (isSubmitted && !formData.userName) &&
                                            <p className="error">*Campo Username obligatorio.</p>
                                        }
                                        {
                                            (isValidEmail) &&
                                            <p className="error">*No es un correo valido.</p>
                                        }
                                        <input
                                            disabled={disablesInputs || edit}
                                            type="text"
                                            value={formData.userName}
                                            onChange={(e) => { onFormDataChange("userName", e.target) }}
                                            onBlur={() => handleBlur(formData.userName)}
                                            maxLength="300" className="form-control black-border large-input" />

                                    </div>
                                </div>
                                <div className="col-6 form-group with-message">
                                    <label className="input-label form-label">
                                        * Nombre Completo
                                    </label>
                                    <div className="">
                                        {
                                            (isSubmitted && !formData.fullName) &&
                                            <p className="error">*Campo Nombre Completo obligatorio.</p>
                                        }
                                        {
                                            (isSubmitted && formData?.fullName && formData?.fullName.trim() == "") &&
                                            <p className="error">*No se permiten solo espacios.</p>

                                        }
                                        <input type="text" value={formData.fullName} onChange={(e) => { onFormDataChange("fullName", e.target) }} maxLength="300" className="form-control black-border large-input" />

                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group with-message col-6">
                                    <label className="input-label form-label">
                                        * Rol
                                    </label>
                                    <div className="">
                                        {
                                            (isSubmitted && !formData.rol) &&
                                            <p className="error">*Campo Rol obligatorio.</p>
                                        }
                                        <Dropdown value={formData.rol} options={catalogs.roles} onChange={(e) => { onFormDataChange("rol", e) }} optionValue="roleID" optionLabel="name" className="w-100" />

                                    </div>
                                </div>
                                <div className="col-6 form-group with-message">
                                    <label className="input-label form-label">
                                        * Estatus
                                    </label>
                                    <div className="">
                                        {
                                            (isSubmitted && !formData.status) &&
                                            <p className="error">*Campo Estatus obligatorio.</p>
                                        }
                                        <Dropdown disabled={disablesInputs} value={formData.status} options={[{ "id": 1, "status": "Activo" }, { "id": 0, "status": "Inactivo" }]} onChange={(e) => { onFormDataChange("status", e) }} optionValue="id" optionLabel="status" className="w-100" />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 form-group with-message">
                                    <label className="input-label form-label">
                                        * Oficina
                                    </label>
                                    <div className="">
                                        {
                                            (isSubmitted && !formData.office) &&
                                            <p className="error">*Campo oficina obligatorio.</p>
                                        }
                                        <Dropdown value={formData.office} options={catalogs.offices} onChange={(e) => { onFormDataChange("office", e) }} optionValue="officeID" optionLabel="name" className="w-100" />

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div
                        className="container d-flex justify-content-end mt-5">
                        <button className="btn btn-white " onClick={() => { handleClose() }}>Cancelar</button>

                        <button className="btn btn-primary ml-3" onClick={sendData}>{edit ? "Editar" : "Agregar"}</button>
                    </div>
                </Modal.Body>
            </Modal>
        </section>
    )
}
export default ModalCreateUser